import { UseAutoCompletedAll } from "src/Contexts/Utils/UseAutoCompletedAll";
import { AutoCompleteGeneric } from "src/Pages/components/InputAutoCompleted/AutoCompleteGeneric";
import { IPropsAutoCompleted } from "src/Pages/components/InputAutoCompleted/types";

export const AutoCompleteFilias = (props: IPropsAutoCompleted) => {
  const {
    label,
    width,
    variant,
    tamanho,
    disabled,
    minWidth,
    maxWidth,
    fullWidth,
  } = props;

  const { setValueAutoProdutor, valueAutoProdutor } = UseAutoCompletedAll();

  return (
    <AutoCompleteGeneric
      disabled={disabled}
      fullWidth={fullWidth}
      label={label}
      maxWidth={maxWidth}
      minWidth={minWidth}
      setValueAutoCompleted={setValueAutoProdutor}
      tamanho={tamanho}
      url="/GetAllFiliais"
      valueAutoCompleted={valueAutoProdutor}
      variant={variant}
      width={width}
    />
  );
};
